import React, { useState, useEffect } from 'react';

export const HoneycombBackground: React.FC = () => {
  const [totalHexagons, setTotalHexagons] = useState(1000); // Valor por defecto alto

  useEffect(() => {
    const calculateHexagons = () => {
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      const hexagonSize = 60; // Tamaño aproximado de cada hexágono
      const columns = Math.ceil(viewportWidth / hexagonSize) + 4; // +4 para asegurar cobertura
      const rows = Math.ceil(viewportHeight / (hexagonSize * 0.866)) + 4; // 0.866 es la altura del hexágono
      const total = columns * rows;
      setTotalHexagons(total);
    };

    calculateHexagons();
    window.addEventListener('resize', calculateHexagons);
    
    return () => window.removeEventListener('resize', calculateHexagons);
  }, []);

  const hexagons = Array.from({ length: totalHexagons }, (_, i) => i);

  return (
    <div className="fixed inset-0 z-0 overflow-hidden w-screen h-screen bg-gradient-to-br from-gray-50 to-blue-200">
      <div className="grid grid-cols-[repeat(auto-fill,minmax(60px,1fr))] gap-px p-px absolute inset-0 w-full h-full opacity-10">
        {hexagons.map((i) => (
          <div 
            key={i} 
            className="w-full pb-[115.47%] bg-white relative transition-all duration-300 ease-in-out hover:bg-gray-100"
            style={{
              clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)'
            }}
          />
        ))}
      </div>
    </div>
  );
}; 